module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Regular.b339cbc.woff";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/fonts/NotoSansCJKkr-Regular.woff
// module id = dKCl
// module chunks = 0